<template>
  <vs-table :data="data" class="w-full">
    <template slot="header">
      <vs-row>
        <vs-col vs-xs="12" vs-sm="2" vs-lg="2" class="px-2 mb-2">
          <add-vendor class="mt-4" @success="search" />
        </vs-col>
        <vs-col vs-xs="12" vs-sm="10" vs-lg="10" style="display: inline-flex">
          <div class="con-input-search vs-table--search">
            <input class="input-search vs-table--search-input" type="text" v-model="text" @keyup.enter="search" />
            <vs-icon icon="search"></vs-icon>
          </div>
        </vs-col>
      </vs-row>
    </template>
    <template slot="thead">
      <vs-th>
        {{ $tc('vendor') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('rfc') | capitalize }}
      </vs-th>
       <vs-th>
        {{ $t('status') | capitalize }}
      </vs-th>
      <vs-th>
      </vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td>
          {{ data[i].VendorName }}
        </vs-td>
        <vs-td>
          {{ data[i].RFC }}
        </vs-td>
        <vs-td class="text-center">
            <vs-chip :color="data[i].active ? 'success':'primary'" style="width:100px">
                {{ data[i].active ? $t('active') : $t('disabled')  | capitalize }}
          </vs-chip>
        </vs-td>
        <vs-td>
          <switch-status :id="data[i].id" :status="data[i].active" @success="search" />
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import AddVendor from './AddVendor.vue'
import SwitchStatus from './SwitchStatus.vue'
export default {
  components: {
    ActionIcon,
    ThSort,
    AddVendor,
    SwitchStatus
  },
  data() {
    return {
      text: '',
    }
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
  },
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    lock(item) {
      this.$emit('lock', { id: item.VendorId, lock: item.lock })
    },
  },
}
</script>

<style></style>